<template>
    <transition
                enter-to-class="animated rubberBand"
                leave-to-class="animated fadeOut">
        <div class="error-container" v-if="errors_form.has(attribute_name)">
            <span class="error-message">{{ errors_form.first(attribute_name) }}</span>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['attribute_name', 'errors_form']
    }
</script>

<style>
    .error-container{
        width: 100%;
        margin: 0px 0px 0px 0px;
        display: table;
        padding-top: 5px;
        padding-bottom: 5px;
    }
    .error-message{
        color: red;
        float: right !important;
        font-weight: bold;
        font-size: 13px;
    }
</style>